import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { ondemandSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const Ondemand = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.ONDEMAND} items={ondemandSubpages} />
);

export default Ondemand;
